export function uniq<T>(array: T[]): T[] {
  const set = new Set(array);
  const result = Array.from(set.values());
  return result;
}